import React, { useState } from 'react';
import { Line } from '@ant-design/charts';
const LineChart = (props) => {
  // 折线图组件
  const {
    lineData = [],
    xField = 'title',
    yField = 'value',
    seriesField = 'type',
    height = 300,
  } = props;
  if (!lineData) {
    return;
  }
  const config = {
    data: lineData.map((item) => {
      item[yField] = Number(item[yField]);
      return item;
    }),
    xField: xField,
    yField: yField,
    seriesField: seriesField,
    label: {},
    tooltip: {},
    smooth: true,
    point: {
      size: 3,
      shape: 'shape',
      style: {
        fill: '#5B8FF9',
        stroke: '#5B8FF9',
        lineWidth: 2,
      },
    },
    gridStrokeOpacity: 0,
    legend: {
      position: 'top-left',
    },
  };
  return (
    <div style={{ marginTop: '20px' }}>
      <Line {...config} height={height} />
    </div>
  );
};

export default LineChart;
